import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wait",
  "use": "icon-wait-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-wait\"><g fill=\"none\" stroke=\"#9a9fa4\" stroke-width=\"2\"><path data-name=\"路径 688\" d=\"M10.461 5.877v5.3h-3.3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><g data-name=\"椭圆 317\"><circle cx=\"10\" cy=\"10\" r=\"10\" stroke=\"none\" /><circle cx=\"10\" cy=\"10\" r=\"9\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol